export const formatDateUTC7 = (dateInput?: string | Date | null): string => {
  if (!dateInput) return '';

  // If string lacks timezone info, treat it as UTC then convert to UTC+7
  const parseDate = (input: string | Date) => {
    if (input instanceof Date) return input;
    if (typeof input === 'string') {
      const hasTZ = /[Zz]|[+-]\d{2}:?\d{2}$/.test(input);
      return new Date(hasTZ ? input : `${input}Z`);
    }
    return new Date(input);
  };

  const date = parseDate(dateInput);
  if (Number.isNaN(date.getTime())) return '';

  const formatter = new Intl.DateTimeFormat('vi-VN', {
    timeZone: 'Asia/Bangkok',
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const parts = formatter.formatToParts(date);
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find(p => p.type === type)?.value || '';

  return `${get('day')}/${get('month')}/${get('year')} ${get('hour')}:${get('minute')}:${get('second')}`;
};

/** Giống CommonJs.formatDateTime nhưng convert UTC → giờ VN (UTC+7): dd/MM/yyyy HH:mm */
export const formatDateTimeUTC7 = (dateInput?: string | Date | null): string => {
  const full = formatDateUTC7(dateInput);
  return full ? full.replace(/:\d{2}$/, '') : '';
};

